import { render, staticRenderFns } from "./SaleDes.vue?vue&type=template&id=46a6680b&scoped=true&"
import script from "./SaleDes.vue?vue&type=script&lang=js&"
export * from "./SaleDes.vue?vue&type=script&lang=js&"
import style0 from "./SaleDes.vue?vue&type=style&index=0&id=46a6680b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a6680b",
  null
  
)

export default component.exports